// mixin.js
import { AssetState } from '@/assets/ts/model/AssetState';
import { MUTATE_MULTISIG_ACCOUNTS } from '@/store/index';
import { IAsset } from '@/store/modules/asset/interface';
import { MUTATE_ASSET_RAW_HISTORY } from '@/store/modules/asset/mutations';
import { map } from 'lodash';
// import { NetworkType, PublicAccount, TransferTransaction } from 'nem2-sdk';
import { Component, Vue } from 'vue-property-decorator';

// You can declare a mixin as the same style as components.
@Component
export default class AssetMixin extends Vue {
    public async filterAndStoreAsset(multisigAccounts: any[]): Promise<any[]> {
        const assets = await this.filterAssets(multisigAccounts);
        return this.storeAssets(assets);
    }

    public async filterAssets(multisigAccounts: any[]): Promise<IAsset[]> {
        const allAssets: IAsset[] = [];
        await Promise.all(multisigAccounts.map(async (publicAccount: any) => {
            // const publicCertificate = new PublicCertificate(publicAccount);
            // const certificateHistory = new CertificateHistory(publicCertificate);

            // const certificateTransactions = await certificateHistory.fetchAllTransactions();
            // if (certificateTransactions.length) {
            //     const creationTransaction = certificateTransactions[certificateTransactions.length - 1];
            //     if (creationTransaction instanceof TransferTransaction) {
            //      const fetchMessage = messageFromSerializedObject(JSON.parse(creationTransaction.message.payload));
            //         if (fetchMessage instanceof CreationMessage) {
            //             const cert: IAsset = {
            //                 publicKey: publicAccount.publicKey,
            //                 transactions: certificateTransactions,
            //             };
            //             allAssets.push(cert);
            //         }
            //         // else ignore
            //     }
            //     // else ignore
            // } // else igonre
        }));
        return allAssets;
    }

    public storeAssets(assets: IAsset[]): any[] {
        // this method to store multisigaccount list
        for (const asset of assets) {
            this.$store.commit(MUTATE_ASSET_RAW_HISTORY, asset);
        }
        const mapMultisigAccount = map(assets, (asset) => {
            // const multisigAccount: any = {
            //     account: PublicAccount.createFromPublicKey(asset.publicKey, NetworkType.MIJIN_TEST),
            //     state: AssetState.NORMAL,
            // };
            return {};
        });
        this.$store.commit(MUTATE_MULTISIG_ACCOUNTS, mapMultisigAccount);
        return [];
    }

    public storeAssetsInfo(assets: IAsset[]) {
        // this is to store the raw histore of asset
        for (const asset of assets) {
            this.$store.commit(MUTATE_ASSET_RAW_HISTORY, asset);
        }
    }
}
